module.exports = __webpack_public_path__ + "fonts/tenon-italic.woff2";